module.exports = __webpack_public_path__ + "img/bg.573133a3.png";